import theme from "@/theme";

const Isvg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.6673 7.99967C14.6673 11.6816 11.6825 14.6663 8.00065 14.6663C4.31875 14.6663 1.33398 11.6816 1.33398 7.99967C1.33398 4.31778 4.31875 1.33301 8.00065 1.33301C11.6825 1.33301 14.6673 4.31778 14.6673 7.99967ZM8.00065 7.33301C8.36884 7.33301 8.66732 7.63148 8.66732 7.99967V11.3336C8.66732 11.7018 8.36884 12.0003 8.00065 12.0003C7.63246 12.0003 7.33398 11.7018 7.33398 11.3336V7.99967C7.33398 7.63148 7.63246 7.33301 8.00065 7.33301ZM8.00065 5.99967C8.36884 5.99967 8.66732 5.7012 8.66732 5.33301C8.66732 4.96482 8.36884 4.66634 8.00065 4.66634C7.63246 4.66634 7.33398 4.96482 7.33398 5.33301C7.33398 5.7012 7.63246 5.99967 8.00065 5.99967Z"
      fill={theme.palette.custom.mainBlue}
    />
  </svg>
);
export default Isvg;
